import { mutationTypes, actionTypes } from '../../../types';
import { getMultipleLangValues } from '../../../tools/helpers';

const clearStyle = { zoom: 1, x: 0, y: 0 };

const DEFAULT_CAPTION_MIN = 80;

export default {
	state: {
		title: '',
		description: '',
		currentIndex: 0,
		figures: [],
		uiMode: 'alwaysHide',
		canZoom: true,
		guidedMode: false,
		autoPlayVideos: true,
		swipeX: 0,
		hideUi: false,
		openOnImages: false,
		captionHeight: DEFAULT_CAPTION_MIN,
		captionMin: DEFAULT_CAPTION_MIN,
		preloadNearest: 1,
	},
	getters: {},
	mutations: {
		[mutationTypes.gallerySetEntries](state, entries) {
			state.figures = entries.map(entry => initEntry(entry, this.state));

			this.commit(mutationTypes.gallerySetIndex, 0);
		},
		[mutationTypes.gallerySetConfig](state, config) {
			state = Object.assign(state, config);
		},
		[mutationTypes.gallerySetIndex](state, index) {
			if (state.currentIndex !== index) {
				state.figures.forEach(figure => Object.assign(figure.style, clearStyle));
			}

			state.currentIndex = index;
			state.swipeX = 0;
		},
		[mutationTypes.gallerySetSwipeX](state, newValue) {
			state.swipeX = newValue;
		},
		[mutationTypes.gallerySetFigureProp](state, { figureIndex, prop, value }) {
			state.figures[figureIndex][prop] = value;
		},
		[mutationTypes.gallerySetHiddenUi](state, value) {
			state.hideUi = value;
		},
		[mutationTypes.gallerySetCaptionHeight](state, value) {
			state.captionHeight = value;
		},
	},
	actions: {
		[actionTypes.gallerySetIndex](context, newIndex) {
			context.commit(mutationTypes.gallerySetIndex, newIndex);
		},
		[actionTypes.galleryNextIndex](context) {
			const newIndex = (context.state.currentIndex + 1) % context.state.figures.length;

			context.commit(mutationTypes.gallerySetIndex, newIndex);
		},
		[actionTypes.galleryPrevIndex](context) {
			const figureCount = context.state.figures.length;
			const newIndex = (context.state.currentIndex - 1 + figureCount) % figureCount;

			context.commit(mutationTypes.gallerySetIndex, newIndex);
		},
		[actionTypes.gallerySwipe](context, newValue) {
			this.commit(mutationTypes.gallerySetSwipeX, newValue);
		},
		[actionTypes.gallerySetFigureProp](context, payload) {
			this.commit(mutationTypes.gallerySetFigureProp, payload);
		},
		[actionTypes.galleryToggleHiddenUi](context) {
			this.commit(mutationTypes.gallerySetHiddenUi, !context.state.hideUi);
		},
	},
	plugins: [
		store => {
			store.subscribe((mutation, state) => {
				if (mutation.type === mutationTypes.setDatasource) {
					store.commit(mutationTypes.gallerySetConfig, state.dataSourceCFG.configWebClient.gallery);
				}
			});
		},
	],
};

function initEntry(entry, state) {
	const langValues = getMultipleLangValues(entry, Object.keys(entry), state);

	const figure = {
		...langValues,
		style: { ...clearStyle },
		naturalSize: { width: 0, height: 0 },
		gestureStartZoom: null,
		loading: true,
		error: false,
	};

	if (!figure.Sources) {
		console.log('NO IMAGE FOUND');
		figure.loading = false;
		figure.error = true;
	} else {
		// use 2048 res images with package syncer
		figure.Sources = figure.Sources.replace(/\/[0-9]+$/, '/2048');
	}

	return figure;
}
